module.exports = __webpack_public_path__ + "static/media/workfluxPortalLogo.18066f2c.svg";